import { createContext } from "react";

const fileContext = createContext();

export default fileContext;
